<script setup>
import ExplainDirectiveCard from '@/Pages/DomainAnalysis/Partials/ExplainDirectiveCard.vue';
import StatusIcon from '@/Pages/Common/StatusIcon.vue';
import actionType from '@/Common/Enum/ActionType.js';
import ExplainDirectiveRow from '@/Pages/DomainAnalysis/Partials/ExplainDirectiveRow.vue';

defineProps({
  record: Object
});
</script>

<template>
  <div v-if="record.has_certificate" class="mt-2">
    <div class="mt-4 pl-6 font-bold md:pl-8">
      {{ $t('domain_analysis.partials.explain_bimi_certificate.certificate') }}
    </div>
    <ExplainDirectiveCard>
      <ExplainDirectiveRow class="gap-0!">
        {{
          $t('domain_analysis.partials.explain_bimi_certificate.certificate_cn')
        }}
        <template #detail>
          <div class="text-wrap break-all">
            {{ record.certificate_cn }}
          </div>
        </template>
        <template #icon>
          <StatusIcon
            :action-type="
              record.has_valid_certificate
                ? actionType.NO_ACTION
                : actionType.ACTION_REQUIRED
            "
            :tooltip="
              record.has_valid_certificate
                ? $t(
                    'domain_analysis.partials.explain_bimi_certificate.no_error'
                  )
                : $t(
                    'domain_analysis.partials.explain_bimi_certificate.invalid_certificate'
                  )
            "
          />
        </template>
      </ExplainDirectiveRow>

      <ExplainDirectiveRow class="gap-0!">
        Certificate Expiry
        <template #detail>
          <div class="text-wrap break-all">
            {{ record.certificate_expires }}
          </div>
        </template>
      </ExplainDirectiveRow>
    </ExplainDirectiveCard>
  </div>
</template>
